import React, { FC } from "react"

import "./Footer.scss"
import { Container } from "../Container"
import { FooterProps } from "./Footer.types"
import Minimal from "./Layouts/Minimal"
import Full from "./Layouts/Full"

const Footer: FC<FooterProps> = ({
    minimal,
    links,
    brand,
    className,
    ...props
}: FooterProps) => {
    let klass = `zb-footer ${className ?? ""}`

    if (minimal) klass += "zb-footer-minimal"

    brand = brand ?? "NatWest"

    const layoutKlass = `zb-brand-${brand.toLowerCase()}`

    return (
        <footer className={klass} role="contentinfo" {...props}>
            <Container>
                {minimal ? (
                    <Minimal className={layoutKlass} links={links} />
                ) : (
                    <Full className={layoutKlass} links={links} />
                )}
            </Container>
        </footer>
    )
}

export default Footer
